import { render, staticRenderFns } from "./whoAreWe.vue?vue&type=template&id=679fe182&scoped=true&"
var script = {}
import style0 from "./whoAreWe.vue?vue&type=style&index=0&id=679fe182&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679fe182",
  null
  
)

export default component.exports